import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/articles";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-lg text-white"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">评测分类</Link>
              <Link to="/category/recommend" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">使用推荐</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">评测维度</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/resource" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">资源对比</Link>
              <Link to="/category/smooth" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">流畅度评测</Link>
              <Link to="/category/quality" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">画质体验</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">全部评测</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">联系方式</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <span className="flex items-center gap-2">
                <i className="ri-mail-line"></i> contact@mogutv.com
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-wechat-line"></i> 蘑菇视频官方
              </span>
              <span className="flex items-center gap-2">
                <i className="ri-earth-line"></i> www.mogutv.com
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} {siteInfo.name} 版权所有 | 视频平台评测推荐
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}